<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

document.addEventListener("DOMContentLoaded", function() {
    // Select tab headers and content
    const descriptionTabHeader = document.querySelector('a[href="#tab-description"]');
    const reviewsTabHeader = document.querySelector('a[href="#tab-reviews"]');
    const descriptionContent = document.getElementById('tab-description');
    const reviewsContent = document.getElementById('tab-reviews');

    if (descriptionTabHeader && reviewsTabHeader && descriptionContent && reviewsContent) {
        // Remove active/open from Description
        descriptionTabHeader.classList.remove('is-open');
        descriptionContent.classList.remove('is-active');

        // Add active/open to Reviews
        reviewsTabHeader.classList.add('is-open');
        reviewsContent.classList.add('is-active');
    }
});
